<script lang="ts" setup>
import YouCanDoThisCard from '../YouCanDoThis/YouCanDoThisCard.vue';

defineProps<{
  imageNumber: InstanceType<typeof YouCanDoThisCard>['$props']['imageNumber'];
}>();
</script>

<template>
  <YouCanDoThisCard :image-number="imageNumber">
    <template #titleText>
      一人ひとりの希望に沿った<span
        :class="$style['youCanDoThisTitleText--accent']"
        >最適なiDeCo相談</span
      >
    </template>
    <template #detail>
      オカネコでは、一方的な説明はせず、まずはお客様の状況をしっかりとヒアリングし、これを元に、現状の投資額や今後の人生設計に基づいて最適なiDeCoプランをご提案します。教育資金や老後資金、セカンドライフの資金など、あなたの理想や目的に応じた的確なアドバイスを行います。
    </template>
  </YouCanDoThisCard>
</template>

<style lang="scss" module>
.youCanDoThisTitleText {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
